module.exports = __webpack_public_path__ + "img/linyuan4en.4c91b5e3.jpg";